<template>
	<div class="filter">
		<Multiselect v-if="!portfolioView" :portfolioView="portfolioView" :choices="groups" :messageOnEmpty="'Выберите портфели'" @onChange="onGroupChange"/>
		<Multiselect :choices="dates" :portfolioView="portfolioView" :messageOnEmpty="'Выберите отчетные даты'" @onChange="onDateChange"/>
		<label for="" v-if="withCohorts">
			Разбивка данных
			<select name="" id="" @change="onDataGroupingChange">
        <option value="" selected>Отсутствует</option>
				<option value="cohorts">По когортам</option>
				<option value="reportDates" v-if="dateGroupingAvaliable">По отчетным датам</option>
			</select>
		</label>
		<button @click="onSubmitClick">Применить фильтр</button>
	</div>
</template>

<script>
import Multiselect from "@/components/Analytics/Multiselect";

export default {
	name: 'AnalyticsFilter',
	components: {
    Multiselect
  },
	props: {
		dates: Array,
		groups: Array,
		portfolioView: Boolean,
		withCohorts: Boolean,
    dateGroupingAvaliable: Boolean
  },
	methods: {
		onGroupChange(data){
			this.$emit('onGroupChange', data)
		},
		onDateChange(data){
			this.$emit('onDateChange', data)
		},
		onDataGroupingChange(event){
			this.$emit('onDataGroupingChange', event.target.value)
		},
		onSubmitClick(){
			this.$emit('onSubmitClick')
		},
	}
}
</script>

<style scoped>
.filter{
	display: flex;
  align-items: flex-end;
	gap: 20px;
}

button{
	padding: 2px;
}

label{
  display: flex;
  flex-direction: column;
  gap: 5px;
}
</style>
	